export default __webpack_public_path__ + "static/media/kitchen3-after1-1440w.120fc967.webp";